import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alert from "../../components/Alert";
import { Link } from "react-router-dom";
import { loadAccounts } from "../../redux/actions/tally";
import ServerPaginationTable from "../../components/ServerPaginationTable";
import SyncStatus from "../../components/SyncStatus";
import {
  migrateTallyPurchaseOrdersData,
  migratePOToTally,
} from "../../api/index";
import SyncRemarkRender from "../../components/SyncRemarkRender";
import { loadPurchaseOrder } from "../../redux/actions/tally";

const columns = [
  {
    Header: "Voucher ID",
    accessor: "cartBillId",
  },
  {
    Header: "Voucher Date",
    accessor: "billDate",
  },
  {
    Header: "Customer Name",
    accessor: "customerName",
  },
  {
    Header: "Deskera ID",
    accessor: "deskeraId",
  },
  {
    Header: "Deskera Sequence Code",
    accessor: "deskeraDocumentCode",
  },
  {
    Header: "Sync Status",
    accessor: "syncStatus",
    Cell: ({ cell: { row } }) => {
      return (
        <SyncStatus
          status={row.original.syncStatus}
          reason={row.original.reason}
          id={row.original.cartPaymentId}
        />
      );
    },
  },
  {
    Header: "Sync Remarks",
    accessor: "reason",
    disableSortBy: true,
    Cell: ({ cell: { row } }) => {
      let value =
        row.original?.syncStatus !== "SUCCESSFUL" && row.original?.reason
          ? row.original?.reason
          : "";
      return <SyncRemarkRender value={value} id={row.original.id.toString()} />;
    },
  },
];

function PurchaseOrders() {
  const poData = useSelector((state) => {
    return state.tally.purchaseOrders;
  });
  const dispatch = useDispatch();
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const tallyConfig = useSelector((state) => state.tally.accounts);

  useEffect(() => {
    dispatch(loadAccounts());
    dispatch(loadPurchaseOrder());
  }, []);

  const data = useMemo(() => poData.data, [poData]);

  useEffect(() => {
    setLoading(false);
    if (poData && poData?.data?.totalPages) {
      setPageCount(poData?.data?.totalPages);
    }
  }, [poData]);

  const refreshData = ({ pageSize, pageIndex, status, sortBy, search }) => {
    setLoading(true);
    dispatch(
      loadPurchaseOrder(pageSize, pageIndex, status, sortBy, search ?? "")
    );
  };

  return (
    <>
      <div className='p-4'>
        <h3 className='mb-3'>Purchase Orders</h3>
        {!tallyConfig.data ||
          (!tallyConfig.data.syncEnable && (
            <Alert type='warning'>
              Your synced Purchase orders will appear here. Please complete{" "}
              <Link to='/app/tally' className='text-alert-warning'>
                <u>Setup</u>
              </Link>{" "}
              before continuing.
            </Alert>
          ))}
        <ServerPaginationTable
          data={data?.content ? data.content : []}
          columns={columns}
          migrate={migrateTallyPurchaseOrdersData}
          syncToTally={migratePOToTally}
          cart='tally'
          refresh={refreshData}
          tab='Purchase Orders'
          pageCount={pageCount}
          loading={loading}
          rowId='id'
        />
      </div>
    </>
  );
}

export default PurchaseOrders;
